/* eslint react/jsx-filename-extension: 0 */
import React, { Component } from 'react';
import { BrowserRouter } from 'react-router-dom';
import { Container } from 'semantic-ui-react';

import './static/App.css';
import filterLanguage from './components/filterLanguage';
import Routes from './Routes';

const initialState = {
  hasError: false,
  error: '',
  info: '',
};

class App extends Component {
  constructor(props) {
    super(props);
    const pageData = filterLanguage(window.pageData);
    this.state = { ...Object.assign(initialState, pageData) };
    this.handleNavClick = this.handleNavClick.bind(this);
  }

  handleNavClick = (e, { name }) => this.setState({ currentNav: name });

  componentDidCatch(error, info) {
    this.setState({ hasError: true, error, info });
  }

  render() {
    const { error, info } = this.state;
    return error ? (
      <p>{String(info)}</p>
    ) : (
      <BrowserRouter>
        <div>
          <div className="padding" />
          <Container>
            <Routes {...this.state} setPlaylists={this.setPlaylists} />
          </Container>
          <div className="padding" />
        </div>
      </BrowserRouter>
    );
  }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js